import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("kiq_token");
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      if (data && data.id) localStorage.setItem("kiq_uid", data.id);
      setUser(data);
    } catch {
      localStorage.removeItem("kiq_token");
      localStorage.removeItem("kiq_uid");
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem("kiq_token", token);
    if (u && u.id) localStorage.setItem("kiq_uid", u.id);
    setUser(u);
    refresh();
  };
  const logout = () => {
    localStorage.removeItem("kiq_token");
    localStorage.removeItem("kiq_uid");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}
